import { Component, inject, input } from '@angular/core';
import { QuickMenuItem } from './menu-item.model';
import { MatIconModule } from '@angular/material/icon';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";
import {MatButtonModule} from "@angular/material/button";
import {Router} from "@angular/router";
import {CHECK_PERMISSIONS} from "@shared/modules/permissions.module";
import { MatCardModule } from '@angular/material/card';
import { ActionCardComponent } from '../../../../momentum-components/components/action-card/action-card.component';

@Component({
  selector: 'app-quick-menu',
  imports: [MatIconModule, MatButtonModule, ...SHARED_IMPORTS, MatCardModule, ActionCardComponent],
  templateUrl: './quick-menu.html',
  styles: ``,
})
export class QuickMenu {
  private router = inject(Router);
  readonly items = input<QuickMenuItem[]>([]);
  protected readonly verifyPermissions = CHECK_PERMISSIONS();
  navigateTo(route: string): void {
    void this.router.navigate([route]);
  }
}
